import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '80vw',
  },
  card: {
    width: '200px !important',
    height: '200px !important',
    margin: '0 30px 20px 0 !important',
    borderRadius: '4px !important',
    cursor: 'pointer !important',
  },
  thumbnail: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  thumbnailImage: {
    marginBottom: '10px',
  },
  title: {
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#152C73',
  },
  noCursor: {
    cursor: 'unset !important',
  },
}), { name: 'quick-links' });
